export default __webpack_public_path__ + "static/media/slot16.d12c63b1.png";